import request from '@/api/request';
const defaultRequest = request();
const simRequest = request(process.env.SIM_API);

export function getSims (params) {
  return defaultRequest({
    url: '/sim',
    method: 'get',
    params
  });
}

export function searchSim (params) {
  return simRequest({
    url: '/sim/search',
    method: 'get',
    params
  });
}

export function createSim (data) {
  return defaultRequest({
    url: '/sim',
    method: 'post',
    data
  });
}

export function importSims (data) {
  return defaultRequest({
    url: '/sim/import',
    method: 'post',
    data
  });
}

export function updateSim (data) {
  return defaultRequest({
    url: '/sim',
    method: 'put',
    data
  });
}

export function moveSims (data) {
  return defaultRequest({
    url: '/sim/move',
    method: 'put',
    data
  });
}

export function deleteSims (ids) {
  return defaultRequest({
    url: '/sim/delete',
    method: 'put',
    data: { ids }
  });
}

export function returnSims (data) {
  return defaultRequest({
    url: '/sim/return',
    method: 'put',
    data
  });
}

export function updateSimData (data) {
  return defaultRequest({
    url: '/sim/importsimdata',
    method: 'post',
    data
  });
}

export function getSimDataByTime (params) {
  return defaultRequest({
    url: '/sim/getsimdatabytime',
    method: 'get',
    params
  });
}


// WEBPACK FOOTER //
// ./src/api/sim.js